import { Input, InputProps, InputRef } from "antd";
import { forwardRef } from "react";
import { TextAreaProps } from "antd/es/input";
import { TextAreaRef } from "antd/es/input/TextArea";

export const VLInput = forwardRef<InputRef, InputProps>(
  ({ autoComplete = "off", ...rest }, ref) => {
    return <Input ref={ref} autoComplete={autoComplete} {...rest} />;
  },
);

export const VLTextArea = forwardRef<TextAreaRef, TextAreaProps>(
  ({ autoComplete = "off", ...rest }, ref) => {
    return <Input.TextArea ref={ref} autoComplete={autoComplete} {...rest} />;
  },
);
